export default {
  list: {
    ACTIONS: 'Actions',
    CONFIRM_DELETION: 'Are you sure?',
    DELETE_HOVER_INFO: 'Delete',
    EDIT_HOVER_INFO: 'Edit',
    SHOW_MORE: 'Show more',
    SHOW_MORE_INFO: 'Show more info',
    UNAUTHORIZED: 'Unauthorized',
  },
};
